import React from 'react';
import './about.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const About = () => {
  return (
    <>
        <Header />
        <div className='corporate-about-container'>
            {/* Giriş ve Tanıtım Alanı */}
            <div className='corporate-about-banner'>
                <img 
                    className='corporate-about-logo' 
                    src="https://www.onder.org.tr/assets/images/statics/onder-logo.svg" 
                    alt="Önder Logo" 
                />
                <h1 className='corporate-about-banner-title'>Hakkımızda</h1>
                <p className='corporate-banner-subtitle'>
                    ÖNDER İmam Hatipliler Derneği olarak geliştirdiğimiz Kariyer Platformu'nda, sadece derneğimiz bünyesindeki iş ilanları paylaşılmaktadır.
                </p>
            </div>

            {/* Bilgi Kartları Alanı */}
            <div className='corporate-about-content'>
                <div className='corporate-about-card'>
                    <h2 className='corporate-card-title'>ÖNDER Kariyer Platformu Nedir?</h2>
                    <p className='corporate-card-text'>
                        ÖNDER Kariyer Platformu, derneğimiz bünyesindeki iş fırsatlarını geniş bir kitleye sunan özel bir kariyer ağıdır. Platform, iş ilanlarıyla derneğimizin projelerinde görev alacak yetenekleri bir araya getirmeyi amaçlar.
                    </p>
                </div>

                <div className='corporate-about-card'>
                    <h2 className='corporate-card-title'>Kimler Başvurabilir?</h2>
                    <p className='corporate-card-text'>
                        Platformumuzdaki ilanlara herkes başvurabilir. İmam hatip mezunu veya dernek üyesi olma şartı olmaksızın, ilanlara erişim sağlayarak özgeçmiş oluşturabilir ve uygun pozisyonlara başvuruda bulunabilirsiniz.
                    </p>
                </div>

                <div className='corporate-about-card full-width-card'>
                    <h2 className='corporate-card-title'>Hedefimiz Nedir?</h2>
                    <p className='corporate-card-text'>
                        Hedefimiz, hem mezunlarımızı hem de topluluğumuz dışındaki yetenekleri değerlendirerek, onları derneğimizin projeleri ve iş imkanlarıyla buluşturmak ve böylece geniş bir kariyer ağı oluşturmaktır.
                    </p>
                </div>
            </div>
        </div>
        <Footer />
    </>
  );
};

export default About;